module.exports = __webpack_public_path__ + "media/images/icon/white/ico_arrow-75fb32b462940f50a8ff42e360308bc2.svg";